import { render, staticRenderFns } from "./travel-document-info.vue?vue&type=template&id=16396bc0&scoped=true&"
import script from "./travel-document-info.vue?vue&type=script&lang=js&"
export * from "./travel-document-info.vue?vue&type=script&lang=js&"
import style0 from "./travel-document-info.vue?vue&type=style&index=0&id=16396bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16396bc0",
  null
  
)

export default component.exports